import { ContactFormLanding } from './ContactFormLanding';

export type { TypeContactFormLandingProps } from './types';
export default ContactFormLanding;
